var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeauturedIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#191919"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 46.1666H18.6663M18.6663 46.1666H35.333M18.6663 46.1666V23.1669C18.6663 21.3001 18.6663 20.366 19.0297 19.6529C19.3492 19.0257 19.8588 18.5161 20.486 18.1966C21.199 17.8333 22.1332 17.8333 24 17.8333H30C31.8668 17.8333 32.799 17.8333 33.512 18.1966C34.1392 18.5161 34.6505 19.0257 34.9701 19.6529C35.333 20.3653 35.333 21.2982 35.333 23.1614V32.8333M35.333 46.1666H45.333M35.333 46.1666V32.8333M45.333 46.1666H48.6663M45.333 46.1666V32.8333C45.333 31.2801 45.3328 30.5039 45.0791 29.8914C44.7408 29.0746 44.0925 28.4253 43.2757 28.087C42.6631 27.8333 41.8857 27.8333 40.3326 27.8333C38.7794 27.8333 38.0029 27.8333 37.3903 28.087C36.5735 28.4253 35.9251 29.0746 35.5867 29.8914C35.333 30.5039 35.333 31.2801 35.333 32.8333M23.6663 29.4999H30.333M23.6663 24.4999H30.333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeauturedIcon3);
export default __webpack_public_path__ + "static/media/feauturedIcon3.785ea1b4d7b611cf7cb01ad28f1ef342.svg";
export { ForwardRef as ReactComponent };